export default __webpack_public_path__ + "3601093df761d0eeff646ebc31c76c97.svg";